jQuery(document).ready(function($){
	
	//********************************
	//MODAL AUTOLOAD
	//********************************
	if ($.fn.modal){
		$('body.wpk-js .modal.auto').modal('show');
	}
	
	
	//********************************
    //HCP CONSENT MODAL AUTOLOAD
	//********************************
	if($('#wpk-hcp-consent').length) {
		//Auto load modal on all pages (popup-hcp.php)
		$('#wpk-hcp-consent').modal('show');
		//Yes
		$('#wpk-hcp-accept-button').on('click', function(){
			document.cookie = "wpk_hcp=true; path=/; SameSite=Strict"; //No expire = session cookie
			$('#wpk-hcp-consent').modal('hide');
		});
		$('#wpk-hcp-dismiss-button').on('click', function(){
			document.cookie = "wpk_hcp=false; path=/; SameSite=Strict"; //No expire = session cookie
			//Get customizer settings url from data value
			var hcp_url = $(this).attr('data-url');
			//forward user to url
			location.href= hcp_url;
		});
	}

	//********************************
    //CONTENT BLOCK MODAL AUTOLOAD
	//********************************
	if($('#wpk-content-block-modal').length) {
		//Auto load modal on all pages (popup-content-block.php)
		$('#wpk-content-block-modal').modal('show');

		//On NO button click
		$('#wpk-content-block-modal-dismiss-button').on('click', function(){
			document.cookie = "wpk_content_block_modal=false; path=/; SameSite=Strict"; //No expire = session cookie
			//Get customizer settings url from data value
			var content_block_url = $(this).attr('data-url');
			//forward user to url
			location.href= content_block_url;
			//Stop click from bubbling up to parent and runing below code.
			return false;
		});

		//On click inside modal (links, buttons etc)
		$('#wpk-content-block-modal').on('click', function(){
			document.cookie = "wpk_content_block_modal=true; path=/; SameSite=Strict"; //No expire = session cookie
			$('#wpk-content-block-modal').modal('hide');
		});
		
	}


	//********************************
    //PASSWORD MODAL AUTOLOAD
	//********************************
	if($('#wpk-modal-password').length) {
		//Auto load modal on all pages (popup-hcp.php)
		$('#wpk-modal-password').modal('show');
		$('#wpk-modal-password button').on('click', function(){
			if($('#wpk-modal-password input').val() == wpk_script_object.modal_pswd) {
				document.cookie = "wpk_password=true; path=/; SameSite=Strict"; //No expire = session cookie
				$('#wpk-modal-password').modal('hide');
			}
			
		});
	}
    
}); //End jQuery